module.exports = __webpack_public_path__ + "static/img/Amsterdam.fb345b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Amsterdam.jpg
// module id = WAo8
// module chunks = 1